import { useReducer, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import UserInteractionLineChart from "../Analysis/UserInteractionLineChart";
import { useSelector } from "react-redux";
import CountryChart from "../Analysis/CountryChart";

const initialization = {
  userInterrationLineChart: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_USER_INTERACTION_DATA":
      return {
        ...state,
        userInterrationLineChart: action.payload,
      };
    case "CLEAR_USER_INTERACTION_DATA":
      return {
        ...state,
        userInterrationLineChart: [],
      };
    default:
      return state;
  }
};

const Analysis = ({ botId }) => {
  const [state, dispatch] = useReducer(reducer, initialization);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [period, setPeriod] = useState(7);
  const user = useSelector((s) => s.user.user);

  const handleExport = () => {
    const chartData = state.userInterrationLineChart;

    if (!chartData || chartData.length === 0) {
      alert("No data available to export.");
      return;
    }

    const csvHeader = ["Date", "Total Hits"];
    const csvRows = chartData.map(({ date, total_hits }) => [date, total_hits]);
    const csvContent = [csvHeader, ...csvRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "user_interactions.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex flex-col p-6 py-4 gap-4 w-full">
      <h1 className="text-2xl font-semibold text-gray-600">Analysis</h1>

      {/* Filter and Export Controls */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
        <div className="flex gap-3 flex-wrap">
          <DatePicker
            selected={startDate}
            onChange={(date) => {
              setStartDate(date);
              setPeriod(null);
            }}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText="Start Date"
            className="border px-3 py-2 rounded-md shadow-sm w-40"
          />
          <DatePicker
            selected={endDate}
            onChange={(date) => {
              setEndDate(date);
              setPeriod(null);
            }}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText="End Date"
            className="border px-3 py-2 rounded-md shadow-sm w-40"
          />
          <select
            value={period || ""}
            onChange={(e) => {
              const val = Number(e.target.value);
              setPeriod(val);
              setStartDate(null);
              setEndDate(null);
            }}
            className="p-2 border rounded">
            <option value="">Select Period</option>
            <option value={7}>Last Week</option>
            <option value={30}>Last Month</option>
            <option value={90}>Last 3 Months</option>
            <option value={180}>Last 6 Months</option>
            <option value={365}>Last Year</option>
          </select>
        </div>

        <button
          onClick={handleExport}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 text-sm">
          Export CSV
        </button>
      </div>

      {/* Chart */}
      <div className="border p-4 rounded-md text-gray-500 bg-gray-50">
        <UserInteractionLineChart
          botId={botId}
          start={startDate}
          end={endDate}
          period={period}
          state={state}
          dispatch={dispatch}
        />
        <CountryChart botId={botId} userId={user?.userId} />
      </div>
    </div>
  );
};

export default Analysis;
